// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

/**
 *
 * @param {array} array Array that should be converted
 * @param {string} key Key that will be used for object, like "id"
 *
 * @returns {object} Hash map
 * @example convertArrayToHashMap([{ id:463, name: "Sydney" }], "id")
 * Will return
 * {
 *   463: { id: 463, name: "Sydney" }
 * }
 */
export const convertArrayToHashMap = (array, key) => {
  return array.reduce((acc, item) => {
    acc[item[key]] = item
    return acc
  }, {})
}

/**
 * Deep equality check for the recursed data structure
 * @param a DS
 * @param b DS
 * @returns {boolean} Whether they are equal
 */
export function deepEqual(a, b) {
  if (a === b) {
    return true
  }

  if (a == null || typeof a != 'object' || b == null || typeof b != 'object') {
    return false
  }

  var propertiesInA = 0,
    propertiesInB = 0
  for (var property in a) {
    propertiesInA += 1
  }
  for (var property in b) {
    propertiesInB += 1
    if (!(property in a) || !deepEqual(a[property], b[property])) {
      return false
    }
  }
  return propertiesInA == propertiesInB
}
